<template>
  <div class="customer-card mt-2">
      <b-card id="page-customer-detail" v-if="!!customer.nameClient" class="customer-detail-card">
        <b-card-header class="customer-detail-header p-0">
          <div class="customer-heading">
            <b-avatar
              :text="customerInitials"
              variant="light-primary"
              size="42"
              class="customer-avatar"
            />
            <div class="customer-heading-copy">
              <small class="text-muted">{{ $t(label('customer')) }}</small>
              <h4 class="mb-25">{{ customer.nameClient }}</h4>
              <small class="text-muted">{{ $t(label('customerSectionHelp')) }}</small>
            </div>
          </div>

          <b-button
            v-if="option === 2 && !blockStatus"
            variant="flat-dark"
            class="btn-icon ml-auto mr-2"
            size="sm"
            :title="$t('edit')"
            @click="$emit('edit-order')"
          >
            <feather-icon icon="Edit2Icon" size="21" />
          </b-button>

          <b-button
            :aria-expanded="visible ? 'true' : 'false'"
            @click="visible = !visible"
            variant="flat-dark"
            class="btn-icon"
            size="sm"
            :title="$t(label(visible ? 'hideDetails' : 'showDetails'))"
            :class="visible ? null : 'collapsed'"
          >
            <feather-icon :icon="visible ? 'EyeOffIcon' : 'EyeIcon'" size="21" />
          </b-button>
        </b-card-header>

        <b-collapse
          id="detail-customer"
          v-model="visible"
          class="customer-detail-list mt-2"
        >
          <b-card-text class="customer-detail-row">
            <feather-icon
              icon="MailIcon"
              size="21"
              class="customer-detail-icon text-info"
            />
            <span class="customer-detail-copy">
              <small>{{ $t(label('email')) }}</small>
              <strong>{{ customer.emailClient || '-' }}</strong>
            </span>
          </b-card-text>
          <b-card-text class="customer-detail-row">
            <feather-icon
              icon="SmartphoneIcon"
              size="21"
              class="customer-detail-icon darken-2"
            />
            <span class="customer-detail-copy">
              <small>{{ $t(label('phone')) }}</small>
              <strong>{{ customer.phoneClient || '-' }}</strong>
            </span>
          </b-card-text>
          <b-card-text class="customer-detail-row">
            <feather-icon
              icon="HomeIcon"
              size="21"
              class="customer-detail-icon text-success"
            />
            <span class="customer-detail-copy">
              <small>{{ $t(label('mainAddress')) }}</small>
              <strong>{{ customer.addressClient || $t('pages.customers.noDirection') }}</strong>
            </span>
          </b-card-text>
          <b-card-text class="customer-detail-row customer-detail-row--address">
            <feather-icon
              icon="MapPinIcon"
              size="21"
              class="customer-detail-icon text-danger"
            />
            <span class="customer-detail-copy">
              <small>{{ $t(label('shippingAddress')) }}</small>
              <strong>{{ customer.shippingAddressClient || $t('pages.customers.directionNoRegistered') }}</strong>
            </span>
          </b-card-text>
          <b-card-text class="customer-detail-row mb-0">
            <feather-icon
              icon="TruckIcon"
              size="21"
              class="customer-detail-icon text-warning"
            />
            <span class="customer-detail-copy">
              <small>{{ $t(label('deliveryCost')) }}</small>
              <strong>{{ customer.shipping ? customer.shipping.nameOfPersonSending : $t('free') }}</strong>
            </span>
          </b-card-text>
        </b-collapse>
      </b-card>
    </div>
  </template>

  <script>
  import {
    BCard, 
    BCardHeader,
    BCardTitle, 
    BCardText, 
    BButton,
    BAvatar,
    BCollapse,
    VBToggle,
  } from 'bootstrap-vue'
  
  export default {
    props: {
      option: {
        type: Number,
        default: () => 1,
      },
      blockStatus: {
        type: Boolean,
        default: () => false,
      },
      customer: {
      type: Object,
      default: () => {},
      },
    },

    components: {
      BCard,
      BCardHeader,
      BButton,
      BCardTitle,
      BCardText,
      BAvatar,
      BCollapse,
      VBToggle,
    },
    directives: {
      'b-toggle': VBToggle,
    },
    data() {
      return {
        visible: true
      }
    },

    computed: {
      customerInitials() {
        return String(this.customer?.nameClient || '')
          .trim()
          .split(/\s+/)
          .slice(0, 2)
          .map(part => part.charAt(0))
          .join('')
          .toUpperCase()
      },
    },

    methods: {
      label(field) {
        return `pages.orders.form.label.${field}`;
      },
    }
  }
  </script>

  <style lang="scss" scoped>
  .customer-card {
    width: 100%;
  }

  .customer-detail-card {
    border: 0;
    border-radius: 0.65rem;
    box-shadow: 0 4px 18px rgba(34, 41, 47, 0.08);
  }

  .customer-detail-header,
  .customer-heading {
    display: flex;
    align-items: center;
  }

  .customer-detail-header {
    gap: 0.5rem;
  }

  .customer-heading {
    min-width: 0;
    gap: 0.85rem;
  }

  .customer-avatar {
    flex: 0 0 auto;
  }

  .customer-heading-copy {
    min-width: 0;
  }

  .customer-detail-list {
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
  }

  .customer-detail-row {
    display: flex;
    align-items: flex-start;
    gap: 0.85rem;
    margin-bottom: 0;
    line-height: 1.45;
    overflow-wrap: anywhere;
  }

  .customer-detail-copy {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 0.15rem;
  }

  .customer-detail-copy small {
    color: #b9b9c3;
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .customer-detail-copy strong {
    color: inherit;
    font-weight: 500;
  }

  .customer-detail-icon {
    flex: 0 0 21px;
    margin-top: 0.1rem;
  }

  .customer-detail-row--address {
    padding: 0.75rem;
    border-radius: 0.357rem;
    background-color: rgba(115, 103, 240, 0.045);
  }
  </style>
